module.exports = __webpack_public_path__ + "static/media/julie.07f255f8.jpg";